module.exports = __webpack_public_path__ + "img/cpyhb.e5b5cc25.png";